export default __webpack_public_path__ + "static/media/OBSERVATION-SUR LE-PATRIMOINE-BATI.76cca97f.svg";